var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert',{staticClass:"py-3 ps-8 text-start text-xs",attrs:{"type":"info","has-border":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"flex items-center"},[_c('icon',{attrs:{"icon":"certified","width":"24","height":"24"}}),_vm._v(" "),_c('p',{staticClass:"text-base font-medium ps-2 text-dark-gray"},[_vm._v("\n        "+_vm._s(_vm.$t('organisms.info_box.certified', {
            brandTitle: _vm.product.brandTitle,
          }))+"\n      ")])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }